import { Loader } from './styles'

export default Loader
